import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import { get } from 'lodash'
import {
  CONFIG_KEYS,
  getClientConfigValue,
} from '../../../shared/helpers/config-helper'
import { GRAPHQL_V2_VERSION_NUMBER } from '../../constants'
import errorLink from './error-link'

export default function makeApolloClient({
  hydrateCacheFrom,
  makeStateLink,
  schema,
  clientOpts = {},
  linkOpts = {},
}) {
  const makeHttpLink = uri => new HttpLink({ uri, ...linkOpts })
  const contentV1Uri = getClientConfigValue(CONFIG_KEYS.CONTENT_SERVICE)
  const contentV2Uri = getClientConfigValue(CONFIG_KEYS.CONTENT_SERVICE_V2)
  const httpLinkV1 = makeHttpLink(contentV1Uri)
  const httpLinkV2 = makeHttpLink(contentV2Uri)

  const serviceLink = ApolloLink.split(
    operation =>
      get(operation.getContext(), 'version', 1) === GRAPHQL_V2_VERSION_NUMBER,
    httpLinkV2,
    httpLinkV1
  )
  const cacheOptions = schema
    ? {
        fragmentMatcher: new IntrospectionFragmentMatcher({
          introspectionQueryResultData: schema,
        }),
      }
    : undefined

  const unhydratedCache = new InMemoryCache(cacheOptions)
  const cache = hydrateCacheFrom
    ? unhydratedCache.restore(hydrateCacheFrom)
    : unhydratedCache
  const link = ApolloLink.from([
    // Ensure stateLink is before httpLink so locals are resolved first
    ...(makeStateLink ? [makeStateLink(cache)] : []),
    errorLink,
    serviceLink,
  ])
  return new ApolloClient({ link, cache, ...clientOpts })
}
